import React, { FunctionComponent } from "react";

import { Link, NoDataTile, Separator, Stack, Text } from "@bps/fluent-ui";
import { withPermissions } from "@components/withPermissions";
import { PltUser } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { Permissions } from "@libs/permissions/permissions.enum";

import { BpIdAuditLogList } from "./BpIdAuditLogList";
import { BpIdAuditLogsFilter } from "./BpIdAuditLogsFilter";
import { UserSignInLogsFilter } from "./UserSignInLogsFilter";
import { UserSignInLogsList } from "./UserSignInLogsList";

interface UserSignInLogsProps {
  user: PltUser;
}
export const UserSignInLogsBase: FunctionComponent<UserSignInLogsProps> = props => {
  return (
    <Stack>
      <Separator />
      {props.user.bpIdUserId ? (
        <Stack>
          <Text bold styles={{ root: { paddingBottom: 12 } }}>
            Sign-in logs are updated by Azure hourly, recent sign-ins may not be
            shown yet.
          </Text>
          <Link
            href="/system/plt/b2c-logs"
            target="_blank"
            styles={{ root: { paddingBottom: 12 } }}
          >
            Open B2C log viewer
          </Link>

          <UserSignInLogsFilter>
            {({ values }) => (
              <UserSignInLogsList
                userId={props.user.bpIdUserId}
                startDate={values.startDate}
                endDate={values.endDate}
              />
            )}
          </UserSignInLogsFilter>
          <BpIdAuditLogsFilter>
            {({ values }) => (
              <BpIdAuditLogList
                bpIdUserId={props.user.bpIdUserId!}
                filters={values}
              />
            )}
          </BpIdAuditLogsFilter>
        </Stack>
      ) : (
        <NoDataTile
          styles={{ root: { flexGrow: 1 } }}
          textProps={{ text: "User does not have Bp Id account" }}
          linkProps={{}}
          showBoxShadow={false}
        />
      )}
    </Stack>
  );
};

export const UserSignInLogs = withPermissions(
  UserSignInLogsBase,
  [Permissions.PltBpidUserRead],
  "or"
);
